// Toaster
// =======

import Toastify from 'toastify-js';

const CLASS_INTERACTIVE = 'toastify-interactive';

const DEFAULT_CONFIG = {
    close: true,
    duration: 5000,
    escapeMarkup: false,
};

const ERROR_CONFIG = {
    className: CLASS_INTERACTIVE,
    destination: '/kapcsolat',
    newWindow: true,
};

class Toaster {
    static get CLASS_INTERACTIVE() {
        return CLASS_INTERACTIVE;
    }

    static get ERROR_CONFIG() {
        return ERROR_CONFIG;
    }

    static error(message, config) {
        Toaster.toast({ ...{ text: message, style: 'error', icon: 'exclamation-octagon' }, ...config });
    }

    static success(message, config) {
        Toaster.toast({ ...{ text: message, style: 'success', icon: 'check' }, ...config });
    }

    static toast(config = {}) {
        const title = (config.title) ? `<h6>${config.title}</h6>` : '';
        const cfg = {
            ...DEFAULT_CONFIG,
            ...config,
            ...{ text: `<div class="toastify-content">${title}${config.text || ''}</div>` },
        };
        cfg.className = cfg.className || '';
        if (cfg.style) cfg.className += ` toastify--${cfg.style}`;
        if (cfg.icon) cfg.className += ` icon icon-${cfg.icon}`;
        cfg.className = cfg.className.trim();
        Toastify(cfg).showToast();
    }

    static warning(message, config) {
        Toaster.toast({ ...{ text: message, style: 'warning', icon: 'exclamation-octagon' }, ...config });
    }
}

export default Toaster;
